import { render, staticRenderFns } from "./RegisteredUserDetails.vue?vue&type=template&id=dd97ed16"
import script from "./RegisteredUserDetails.vue?vue&type=script&lang=js"
export * from "./RegisteredUserDetails.vue?vue&type=script&lang=js"
import style0 from "./RegisteredUserDetails.vue?vue&type=style&index=0&id=dd97ed16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports